import "./PerformanceWidget.css";

function BarChart({ data }){
    const maxValue = Math.max(...data.map((item) => item.value), 1);

    return(
        <section className="bar-chart-container" aria-label="Calls by team member">
            <h3>Number of calls</h3>
            <div className="bar-chart-grid">
                {data.map((item) => {
                    const barHeight = (item.value / maxValue) * 100;

                    return (
                        <div className="bar-column" key={item.label} title={`${item.label}: ${item.value} calls`}>
                            <span className="bar-value">{item.value}</span>
                            <div className="bar-item" style={{ height: `${barHeight}%`, backgroundColor: item.color }} />
                            <span className="bar-label">{item.label}</span>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}

export default BarChart;